import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, map, of, switchMap, take } from 'rxjs';
import { UnsavedChangesDialogComponent } from '../ui/dialogs/unsaved-changes-dialog.component';
import { selectHasAllScores } from '../state';
import { selectIsAuthenticated } from '../state/auth/auth.selectors';
import { BASE } from '../../configs/routes.config';

const guardedDestinations = [`/${BASE}/dashboard`, `/${BASE}/account/profile`];

export const unsavedWheelScoresGuard: CanDeactivateFn<unknown> = (_component, _currentRoute, _currentState, nextState) => {
  if (!guardedDestinations.some((destination) => nextState.url === destination || nextState.url.startsWith(`${destination}/`))) {
    return true;
  }

  const store = inject(Store);
  const dialog = inject(MatDialog);

  return combineLatest([store.select(selectIsAuthenticated), store.select(selectHasAllScores)]).pipe(
    take(1),
    switchMap(([isAuthenticated, hasAllScores]) => {
      if (!isAuthenticated || !hasAllScores) {
        return of(true);
      }

      return dialog
        .open(UnsavedChangesDialogComponent, {
          width: '530px',
          disableClose: true,
          data: {},
          panelClass: 'modal-panel',
        })
        .afterClosed()
        .pipe(
          take(1),
          map((result: UnsavedChangesDialogResult | undefined) => {
            return result?.action === 'discard';
          })
        );
    })
  );
};
